import { TagsType } from "@components/Common/HomeworkTemplate/Modals/types";
import { Autocomplete, Box, TextField } from "@mui/material";
import { CommonTagBase } from "@root/endpoints/TimeTactApi/studentApi";

import { useStyles } from "./styles";
import { useTagInputView } from "./tag-input.view";

type Props = {
  tagInputValue: TagsType | null;
  searchedTags: CommonTagBase[];
  isLoadingTags: boolean;
  handleChange: (value: string, shouldSave?: boolean) => void;
  onBlur: () => void;
  loadMore: () => void;
  hasMore: boolean;
};

export const TagInputComponent = ({
  tagInputValue,
  searchedTags,
  isLoadingTags,
  handleChange,
  onBlur,
  loadMore,
  hasMore,
}: Props) => {
  const classes = useStyles();
  const { wrapRef, handleOptionChange, handleInputChange, handleScroll } =
    useTagInputView({
      handleChange,
      loadMore,
      hasMore,
    });

  return (
    <Box
      sx={{
        position: "relative",
      }}
      ref={wrapRef}
    >
      <Autocomplete
        id="tag-input"
        freeSolo
        disableClearable
        blurOnSelect={false}
        onBlur={onBlur}
        open={searchedTags.length > 0}
        defaultValue={tagInputValue?.name}
        options={searchedTags.map((tag) => tag.name)}
        getOptionLabel={(option) => option}
        onChange={handleOptionChange}
        onInputChange={handleInputChange}
        ListboxProps={{
          onScroll: handleScroll,
        }}
        filterOptions={(x) => x}
        loading={isLoadingTags}
        isOptionEqualToValue={(option, value) => option === value}
        renderInput={(params) => (
          <TextField
            {...params}
            autoFocus
            variant="outlined"
            size="small"
            sx={classes.tagInput}
            data-cy="tag-input"
          />
        )}
      />
    </Box>
  );
};
